export enum DeviceType {
  IOS = 'ios',
  Android = 'android',
  Web = 'web',
}
